module.exports = __webpack_public_path__ + "img/maim_no.0b0f47d3.png";